import { parsePhoneNumberFromString } from "libphonenumber-js/min";

export const formatPhoneNumberDisplay = (phone: string): string => {
  if (!phone) {
    return phone;
  }

  const parsed = parsePhoneNumberFromString(phone);

  return parsed ? parsed.formatInternational() : phone;
};
